module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('calculator')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "wrap grid-center"
  }, [_c('div', {
    staticClass: "grid-8 grid-offset-2 text-center"
  }, [_c('h1', [_vm._v("RECOVERY TIME CALCULATOR")]), _vm._v(" "), _c('p', [_vm._v("Evaluate your Recovery Time and Recovery Point Objectives")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15514c9b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 31
// module chunks = 0